export function sortAlphabetical(arr) {
  let list = arr.slice(0)
  list.sort((a,b) => a.name.toUpperCase() < b.name.toUpperCase() ? -1 : a.name.toUpperCase() > b.name.toUpperCase() ? 1 : 0)
  return list
}

export const selectedAlphabetical = [{
  active: true,
  text: "A-Z"
},
{
  active: false,
  text: "Z-A"
},
{
  active: false,
  text: "Worst-Best"
},
{
  active: false,
  text: "Best-Worst"
}]

export function sortAlphabeticalReverse(arr) {
  let list = arr.slice(0)
  list.sort((a,b) => a.name.toUpperCase() > b.name.toUpperCase() ? -1 : a.name.toUpperCase() < b.name.toUpperCase() ? 1 : 0)
  return list
}

export const selectedAlphabeticalReverse = () => [{
  active: true,
  text: "Z-A"
},
{
  active: false,
  text: "A-Z"
},
{
  active: false,
  text: "Worst-Best"
},
{
  active: false,
  text: "Best-Worst"
}]

function compareRating(a,b) {
  const map = {
    Best:0,
    Good:1,
    Average:2,
    Poor:3
  }

  return map[a] - map[b]
}

export function sortWorstBest(arr) {
  let list = arr.slice(0)
  list.sort((a,b) => a.name.toUpperCase() < b.name.toUpperCase() ? -1 : a.name.toUpperCase() > b.name.toUpperCase() ? 1 : 0)
  list.sort((a,b) => -1 * compareRating(a.rating,b.rating))
  return list
}

export const selectedWorstBest  = () => [{
  active: true,
  text: "Worst-Best"
},
{
  active: false,
  text: "A-Z"
},
{
  active: false,
  text: "Z-A"
},
{
  active: false,
  text: "Best-Worst"
}]

export function sortBestWorst(arr) {
  let list = arr.slice(0)
  list.sort((a,b) => a.name.toUpperCase() < b.name.toUpperCase() ? -1 : a.name.toUpperCase() > b.name.toUpperCase() ? 1 : 0)
  list.sort((a,b) => compareRating(a.rating,b.rating))
  return list
}

export const selectedBestWorst  = () => [{
  active: true,
  text: "Best-Worst"
},
{
  active: false,
  text: "A-Z"
},
{
  active: false,
  text: "Z-A"
},
{
  active: false,
  text: "Worst-Best"
}]
